import React from 'react';
import Message from '../components/messages/Message';
import type { WhiteboardIntegration } from '../shared-types';

interface IntegrationUpgradePromptProps {
  integration: WhiteboardIntegration;
}

const IntegrationUpgradePrompt: React.FC<IntegrationUpgradePromptProps> = ({
  integration,
}) => {
  return (
    <Message>
      <p>
        Upgrade to{' '}
        <a href='/suite/whiteboards' target='_blank' rel='noreferrer'>
          Aha! Whiteboards Advanced
        </a>{' '}
        to add {integration.title} records to whiteboards
      </p>
    </Message>
  );
};

export default IntegrationUpgradePrompt;
